import React, {useState, useEffect} from 'react';
import './index.css';
import SerialReview from '../SerialReview';
import ServiceStatus from '../ServiceStatus';
import ServiceHistory from '../ServiceHistory';

const Review = ({ nextRevisionDate, nextRevisionOdometer, nextRevisionNumber, selectedModel, serviceList, completeData }) => {
  const [freeReview, setFreeReview] = useState(false)
  const [warranty, setWarranty] = useState({
    dateLicense: ""
  })
  useEffect(()=>{
    async function fetch(){  
        setTimeout( function(){            
          setFreeReview(completeData.revision.isWithFreeRevisionService)              
        }, 100 );
        
        setWarranty(completeData.warranty)
      }
      
      fetch()            
  },[])

  return (      
    <div>
        { freeReview == true && warranty.dateLicense !== "" ? 
        <SerialReview
            nextRevisionOdometer={nextRevisionOdometer}
            nextRevisionDate={nextRevisionDate}
            nextRevisionNumber={nextRevisionNumber}
        /> : 
        <ServiceStatus
            nextRevisionOdometer={nextRevisionOdometer}
            nextRevisionDate={nextRevisionDate}
            nextRevisionNumber={nextRevisionNumber}
        />
        }
        <ServiceHistory
            serviceList={serviceList}
            isFreeReview={freeReview}
        />
    </div>
  )
}

export default Review
